import styled from 'styled-components'
import Box from './Box'

/**
 * This component is meant for making sure that the content does not reach
 * the edges of the screen on mobile.
 */
const Block = styled(Box)``

Block.defaultProps = {
  paddingX: { xs: 20, md: 36 },
  maxWidth: 'full',
  marginX: 'auto',
}

export default Block
